import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import Panel from 'client/components/aria/Panel/Panel';

const WorkpackAlertSuccess = ({ name, ...props }) => {
    const intl = useIntl();
    const dataTestId = props['data-testid'] || 'workpack-confirmation-panel';

    return (
        <Panel
            {...props}
            data-testid={dataTestId}
            title={
                <div data-testid={`${dataTestId}.title`}>
                    {intl.formatMessage({ id: 'workpackAlerts.success.title' })}
                    {name && <div data-testid={`${dataTestId}.name`} style={{ fontWeight: 'normal', marginTop: '0.5em' }}>{name}</div>}
                </div>
            }
            message={<span data-testid={`${dataTestId}.body`} />}
        />
    );
};

WorkpackAlertSuccess.propTypes = {
    ...defaultAriaProps,
    name: PropTypes.string
};

export default WorkpackAlertSuccess;
